import $ from 'jquery';

function cycleGallery($gallery: JQuery<HTMLElement>): void {
    const $images = $gallery.find('.wp-block-image');
    let currentIndex = 0;

    setInterval(() => {
        $images.eq(currentIndex).fadeOut(1000);
        currentIndex = (currentIndex + 1) % $images.length;
        $images.eq(currentIndex).fadeIn(1000);
    }, 5000); // Change the duration (in milliseconds) to control the speed of the carousel
}

function initCarousel(): void {
    const $gallery = $('.wp-block-plaudit-carousel .wp-block-gallery');

    // Check if there are any carousel elements on the page
    if ($gallery.length === 0) {
        return; // No carousel elements found, exit the function
    }

    cycleGallery($gallery);
}

// Standard JavaScript/TypeScript equivalent to document.ready
document.addEventListener('DOMContentLoaded', function () {
    initCarousel();
});

